import { useEffect } from 'react';
import { Modal } from 'antd';
import { useSelector, useDispatch } from 'react-redux';

// icon
import { FaCheckCircle } from 'react-icons/fa';
//  style
import helperStyle from '../../styles/helperModals.module.scss';
//  redux actions
import { resetHelperModals } from "../../redux/slices/helperModalsSlice";


const SuccessOperation = () => {
  //  variables
  const dispatch = useDispatch();
  const successText = useSelector(state => state.helperModals.successText);
  const successOperation = useSelector(state => state.helperModals.successOperation);


  //  side effects 
  useEffect(() => {
    if (successOperation)
      setTimeout(() => {
        if (successOperation) dispatch(resetHelperModals());
      }, 3000);
  }, [successOperation]);

  return (
    <Modal
      visible
      footer={null}
      closable={false}
      onCancel={() => { if (successOperation) dispatch(resetHelperModals()); }}
      className="modalHasRadius modalHasGreenBorder"
    >
      <div className={helperStyle.successOperationContainer}>
        <FaCheckCircle className={helperStyle.successIcon} />
        <h1 className={helperStyle.text}>
          {
            successText
          }
        </h1>
      </div>

    </Modal>
  );
};


export default SuccessOperation;